const appSettings = {
  ENVIRONMENT_NAME: 'demo',
  SERVICE_VERSION: 'c26d1588e6c926d820ee77dd7de7ffd7f55b7361-demo',
  SIGNOZ_TOKEN: 'Z3HAHc4YSVaRN2lgXLu2OrMcdutt7c3shSE-', //gitleaks:allow //trufflehog:ignore
  STACKDRIVER_API_KEY: 'AIzaSyAnL1trIr6wVSkKXoju2JBD_AdAMNflWhM', //gitleaks:allow //trufflehog:ignore
  STACKDRIVER_LOGGING_ENABLED: true,
  GOOGLE_PROJECT_ID: '38104635069',
  GRAPHQL_SERVER_URL: 'https://api-demo.spoileralert.com/',
  MARKETING_URL: 'https://www.spoileralert.com',
  MARKETING_TERMS_URL: 'http://info.spoileralert.com/terms',
  MARKETING_PRIVACY_URL: 'http://info.spoileralert.com/privacy',
  REFRESH_URL: 'https://demo.spoileralert.com/version',
  GOOGLE_ANALYTICS_ID: 'UA-49684116-4',
  GOOGLE_MAPS_KEY: 'AIzaSyAW6RGdfpLSlB0Plg6m4amVuqCRYYcGe9k', //gitleaks:allow //trufflehog:ignore
  GOOGLE_MAPS_VERSION: '3.37',
  LOTTIE_TIMEOUT: 5,
  // noopengrep: generic.secrets.security.detected-jwt-token.detected-jwt-token
  MAP_BOX_KEY: 'pk.eyJ1Ijoic3BvaWxlcmFsZXJ0IiwiYSI6ImNtbXRkcmQ1dTIwaXAyc3B0d205cm01M2oifQ.hEsW9T3h8ztXuOM1sAy1Kg', //gitleaks:allow //trufflehog:ignore
  CERTIFIED_BUYERS_DL: '67e5842f90940d70dcec0da3',
  USERPILOT_APP_TOKEN: 'STG-NX-52a6755b', //gitleaks:allow //trufflehog:ignore
  MUI_X_LICENSE_KEY:
    '560e693ad9cda8e651cc5bede7229390Tz0xMzMxNTUsRT0xODIxMzk4Mzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9OCxBVD1zaW5nbGUsS1Y9Mg==', //gitleaks:allow //trufflehog:ignore
};

export default appSettings;
